import { Trans } from 'react-i18next';

const CC_BY_URL = 'https://creativecommons.org/licenses/by/4.0/';

type Props = {
    className?: string;
};

/**
 * Crédit des avatars joueurs (banque public/avatars/adventurer) : le style
 * « Adventurer » de Lisa Wischofsky est sous CC BY 4.0, qui impose de créditer
 * l'autrice, de lier la licence et de signaler la modification (remix DiceBear).
 * Affiché là où l'on choisit son avatar, sous la mention de confidentialité.
 */
export function AvatarCredit({ className }: Props) {
    return (
        <p className={className}>
            <Trans
                i18nKey="playerConsent.avatarCredit"
                components={{
                    // Le texte du lien est injecté par <Trans> depuis la traduction.
                    // eslint-disable-next-line jsx-a11y/anchor-has-content, jsx-a11y/control-has-associated-label
                    link: <a href={CC_BY_URL} target="_blank" rel="noopener noreferrer" />,
                }}
            />
        </p>
    );
}
